import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import { Drawer } from "rsuite";

import MarvinInputForm from "./MarvinInputForm";
import GreyCross from "../../../../Icons/Marvin/GreyCrossMarvin.svg";
import {ReactComponent as  NewgenOneMarvin} from "../../../../Icons/Marvin/NewgenOneMarvin.svg";
import { GetState, GetStateFromData } from "../../../CustomHooks/CustomHooks";
import { useDispatch } from "../../../../Redux";
import { updateMarvinContexts } from "../../../../Redux/Actions/FormStateActions";
import { getFormId, resetMarvinStates, sendRequestForMarvin } from "../../IFormDesignerLogic";
import axios from "../../../../axios";
import { sanitizeJson } from "../../../../Resources/globalFunctions";

const { Header, Body, Title, Actions } = Drawer;

export const useStyles = makeStyles(() => ({
  marvinDrawerContainer: {
    "& .rs-tooltip": {
      backgroundColor: "#fff !important",
      color: "#606060 !important",
      border: "1px solid #e7e7e7 !important",
    },
    "& .rs-tooltip[class*='placement-bottom']::after": {
      borderBottomColor: "#e7e7e7 !important",
    }
  },
  drawerContainer: {
    top: (style) => `${style.top} !important`,
    height: (style) => `calc( 100dvh - ${style.top} ) !important`,
    // height: `calc(100vh - ${topInPX} - 2px) !important`,
    width: "360px !important",
    border: "1px solid #c4c4c4"
  },
  header: {
    display: "flex !important",
    alignItems: "center",
    padding: "11px 16px !important",
    borderBottom: "1px solid #e5e5e5",

    "& h2": { margin: "0 !important" }
  },
  title: { lineHeight: "16px !important" },
  crossIcon: { marginLeft: "auto", width: "16px", cursor: "pointer" },
  body: { padding: "0 !important", height: "calc(100% - 45px - 55px) !important" },
  image: {width: "146px", height: "18px"}
}));

const SectionForm = (props) => {
  const dispatch = useDispatch();

  const { containerInfo, renderSectionForm, controlSelected } = GetState("containerInfo", "renderSectionForm", "controlSelected");
  const marvinContexts = GetStateFromData(containerInfo.containerId, "marvinData");
  const contexts = GetStateFromData(props.containerId);

  const { formState2, canvasTop, fetchProcessVariables, showAlertConfirmNotifications,microFrontendData,isPortal,activeApplication } = contexts.contexts;
  const { openMarvinModal, marvinFormJson, marvinRequestSent } = marvinContexts.marvinStates;
  const { inputField = [], formDetails = {}, payload = {} } = marvinFormJson;

  const isProcessForm = microFrontendData?.formPageType === "Processes" && !document.querySelector("#interfaceDesignerMain");
  const classes = useStyles({ top:isProcessForm ? "0px":"48px" });
  const controller = useRef(null);

  useEffect(() => () => resetMarvinStates(), []);

  const setMmarvinRequestSent = (marvinRequestSent) => {
    dispatch(
      updateMarvinContexts({
        key: containerInfo.containerId,
        states: { marvinRequestSent },
        renderSectionForm: true
      })
    );
  };

  async function stopRegeneratingMarvin(newFormBuffer, str = "") {
    const formId = getFormId();
    const id = `${JSON.parse(newFormBuffer).formId}`;

    const repopulateJson = {
      formId: `${formId || id}`,
      formJson: newFormBuffer
    };
    if(isPortal){
      repopulateJson.applicationId=  activeApplication?.applicationId
  }
    const callResponse = await axios
      .post("/idesign/populateFormStateFromJson", sanitizeJson(repopulateJson), {
        withCredentials: true
      })
      .then(() => {
        // fetchProcessVariables(str);
        return true;
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return callResponse;
  }

  const handleClose = async (marvinFormData, action, ev) => {
    try {
      const isFormSubmitted = action === "generate" || action === "addmorefields";

      if (isFormSubmitted) {
        controller.current= new AbortController()
        setMmarvinRequestSent(true);
        const oldControlName = formDetails.values?.[formDetails.controlNameKey];

        const isNameChanged =
          oldControlName &&
          oldControlName.toLowerCase() !== marvinFormData?.[formDetails?.controlNameKey]?.toLowerCase() &&
          action === "addmorefields";

        const jsonToSend = {
          ...marvinFormData,
          action:
            payload.marvinType === "7"
              ? marvinFormData?.generateDataObjects
                ? "reset"
                : action
              : isNameChanged
              ? "reset"
              : action,
          marvinType: payload.marvinType
        };
        await sendRequestForMarvin(jsonToSend, controlSelected, controller.current, containerInfo.containerId);
      } else if (action === "stop") {
        controller.current.abort();
        stopRegeneratingMarvin(JSON.stringify(formState2));
        setMmarvinRequestSent(false);
      } else if (action === "cancel") {
        if (marvinRequestSent) setMmarvinRequestSent(false); // if cancelled after making generate request
        resetMarvinStates();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className={["rsuite_component_parent", classes.marvinDrawerContainer].join(" ")} id="marvin_Drawer_Container">
      <Drawer
        backdrop={false}
        open={openMarvinModal}
        className={classes.drawerContainer}
        container={document.getElementById("marvin_Drawer_Container")}
      >
        <Header closeButton={false} className={classes.header}>
          <Title className={classes.title}>
            <NewgenOneMarvin className={classes.image}/>
          </Title>

          <Actions>
            <img
              onClick={(e) => handleClose({}, "cancel", e)}
              className={classes.crossIcon}
              alt="Close Icon"
              src={GreyCross}
            />
          </Actions>
        </Header>

        <Body className={classes.body}>
          <MarvinInputForm
            containerId={containerInfo.containerId}
            inputField={inputField}
            formDetails={formDetails}
            callbackFn={handleClose}
            states={{ marvinRequestSent }}
            showAlertConfirmNotifications= {showAlertConfirmNotifications}
          />
        </Body>
      </Drawer>
    </div>
  );
};

export default SectionForm;
